(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  if (!mobile.matches) return;

  const exitUrlKey = 'velora-exit-url-v1';
  const homeScrollKey = 'velora-home-scroll-v1';
  const isHome = window.location.pathname.replace(/\/+$/, '') === '';

  try {
    if (document.referrer) {
      const referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) {
        sessionStorage.setItem(exitUrlKey, referrer.href);
      }
    }
  } catch (_error) {
    // A missing or restricted referrer simply leaves normal browser history intact.
  }

  if (!isHome) return;

  const saveHomeScroll = () => {
    try {
      sessionStorage.setItem(homeScrollKey, String(Math.max(0, Math.round(window.scrollY))));
    } catch (_error) {
      // Native scroll restoration remains available if storage is restricted.
    }
  };

  const restoreHomeScroll = () => {
    let savedPosition = null;
    try {
      const storedPosition = sessionStorage.getItem(homeScrollKey);
      if (storedPosition === null) return;
      savedPosition = Number(storedPosition);
    } catch (_error) {
      return;
    }
    if (!Number.isFinite(savedPosition)) return;

    const restore = () => window.scrollTo({ top: savedPosition, left: 0, behavior: 'auto' });
    requestAnimationFrame(() => {
      restore();
      // Lazy images can finish sizing just after the page is restored.
      window.setTimeout(restore, 120);
      window.setTimeout(restore, 420);
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    try {
      const destination = new URL(link.href, window.location.href);
      if (destination.origin === window.location.origin && destination.href !== window.location.href) {
        saveHomeScroll();
      }
    } catch (_error) {
      // Ignore malformed or app-managed links.
    }
  }, true);

  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    if (event.persisted || navigation?.type === 'back_forward') restoreHomeScroll();
  });

  window.addEventListener('popstate', (event) => {
    if (event.state?.veloraHomeBackGuard) restoreHomeScroll();
  });

  let exitUrl = null;
  try {
    exitUrl = sessionStorage.getItem(exitUrlKey);
  } catch (_error) {
    return;
  }
  if (!exitUrl) return;

  const previousState = { ...(history.state || {}) };
  delete previousState.veloraHomeBackGuard;
  const baseState = { ...previousState, veloraHomeBackBase: true };
  history.replaceState(baseState, '', window.location.href);
  history.pushState({ ...baseState, veloraHomeBackGuard: true }, '', window.location.href);

  let isLeaving = false;
  window.addEventListener('popstate', (event) => {
    // Overlay controls place their own history entry above this guard. Let their
    // existing handlers close the overlay first, then handle the next Back tap.
    if (event.state?.veloraHomeBackGuard) return;
    if (isLeaving) return;
    isLeaving = true;

    try {
      sessionStorage.removeItem(exitUrlKey);
    } catch (_error) {
      // The redirect still works if storage was cleared by the browser.
    }
    window.location.replace(exitUrl);
  });
})();
